var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{class:{
    hide: !_vm.showMenu && _vm.$route.name === 'home',
    small: _vm.small,
    home: _vm.$route.name === 'home'
  }},[_c('router-link',{attrs:{"to":{ name: 'home' }}},[_vm._v(" Aspekt Office ")]),_c('router-link',{staticClass:"center",attrs:{"to":{ name: 'projects', params: { id: 'all' } }}},[_vm._v("Projects")]),_c('router-link',{attrs:{"to":{ name: 'about' }}},[_vm._v("Info")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }